module.exports = __webpack_public_path__ + "media/npc_dota_hero_drow_ranger.2e026f83.webm";